<div class="d-flex content flex-column wrapper-main">
  <app-navbar
    [active]="active"
    (collapseToogle)="collapseToogle($event)"
  ></app-navbar>
  <div style="margin-top: 60px" class="d-flex flex-row">
    <div
      class="layer"
      [class.layer-hidden]="!active"
    >
      <nav
        id="sidebar"
        class="sidebar flex-fill"
        [class.collapsed]="!active"
      >
        <app-sidebar [active]="active"></app-sidebar>
      </nav>
    </div>
    <div id="content" #contentRef class="pb-5 mb-5" style="position: relative;">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
